import React from "react";
import { cva, type VariantProps } from "class-variance-authority";
import { cn } from "../../lib/cn";

const skeleton = cva("animate-pulse bg-neutral-200 motion-reduce:animate-none", {
  variants: {
    variant: {
      text: "h-4 rounded-sm",
      circle: "rounded-full",
      rect: "rounded-sm",
    },
  },
  defaultVariants: { variant: "text" },
});

type SkeletonProps = React.HTMLAttributes<HTMLDivElement> & VariantProps<typeof skeleton>;

export function Skeleton({ variant, className = "", ...props }: SkeletonProps) {
  return <div className={cn(skeleton({ variant }), className)} {...props} />;
}
